import _ from 'underscore';
import mediator from '../js/mediator';
import config from '../js/config';
import {getMergedError} from './errorHandling';
import {pluraliseAndTranslate} from './globalisation';
import Analytics from '../components/Analytics/Analytics';

export function checkCartErrorCodesMiddleware(request) {
  let json = request.response;

  if (!json) return;
  if (!json.errors) return;
  if (!json.errors.length) return;
  // Check if any of the errors are related to price change on quantity update
  if (json.errors.length === 1) {
    let priceChangeErrors = _.where(json.errors, { errorCode: config.cart.apiError.priceChange });
    if (priceChangeErrors && priceChangeErrors.length) return;

    /** Check if there is any promotion errors
     * A promotion error occurs when a customer tries to edit the cart and promo is not valid
     * however there action was. At this time we will silently fail
     */
    let promoChangeErrors = _.where(json.errors, { errorCode: config.cart.apiError.promoInvalid });
    if (promoChangeErrors && promoChangeErrors.length) return;
  }

  let error = {
    level: config.error.level.error,
    title: pluraliseAndTranslate('shoppingCart', 'apiGenericError')
  };

  // Check if any of the errors are a maxQuantity
  let maxQuantityErrors = _.where(json.errors, { errorCode: config.cart.apiError.maxQuantity });

  if (maxQuantityErrors && maxQuantityErrors.length) {
    error = {
      level: config.error.level.info,
      title: pluraliseAndTranslate('shoppingCart', 'apiMaxQuantityTitleError'),
      messages: []
    };

    _.forEach(maxQuantityErrors, maxQuantityError => {
      let errorMessage = resolveMaxQuantityProductError(
        maxQuantityError,
        json.entries,
        request.requestOptions.addedProducts || []
      );
      if (errorMessage) {
        error.messages.push(errorMessage);
      }
    });

    // Trigger modal error to display dialog message to inform the user
    mediator.trigger(config.events.error.generic, {error});

  } else {

    switch (json.errors[0].errorCode) {
      case config.cart.apiError.alreadyInCart:
        error.level = config.error.level.info;
        error.title = pluraliseAndTranslate('shoppingCart', 'apiAlreadyInCartTitleError');
        error.messages = [{ message: pluraliseAndTranslate('shoppingCart', 'apiAlreadyInCartError') }];
        break;

      case config.cart.apiError.couldNotFindItem:
        error.title = pluraliseAndTranslate('shoppingCart', 'apiCouldNotFindItemTitleError');
        error.messages = [{ message: pluraliseAndTranslate('shoppingCart', 'apiCouldNotFindItemError') }];
        break;

      // Any other error from the API
      default:
        error.messages = [{ message: pluraliseAndTranslate('shoppingCart', 'apiGenericError') }];
        break;
    }

  }

  // Analytics.push(
  //   config.events.cart.apiError,
  //   config.analytics.categories.cart,
  //   config.analytics.actions.errorModalApiFail,
  //   json.errors[0].errorCode
  // );

  request.error = getMergedError(error);
  throw new Error(error.title);
}

export function resolveMaxQuantityProductError(maxQuantityError, cartEntries, addedProducts) {
  // Get the errorArgs {name: partId value} - find in the Cart product entries by the vendorItemNo - get the catalogSourcePartId
  let vendorItemNo = _.property('value')(_.findWhere(maxQuantityError.errorArgs, { name: 'partId' }));
  let quantity = _.property('value')(_.findWhere(maxQuantityError.errorArgs, { name: 'available' }));
  let sourcePartId = _.property('catalogSourcePartId')(_.findWhere(cartEntries, { vendorItemNo }));

  // Find the relevant part that we initially added and update its quantity
  let addedProduct = _.find(addedProducts, product => product.model.sourcePartId === sourcePartId);
  if (!addedProduct) return;
  addedProduct.quantity = quantity;
  return {
    message: pluraliseAndTranslate('shoppingCart', 'apiMaxQuantityError', { quantity })
  };
}



// WEBPACK FOOTER //
// ./assets/utilities/cartApiRequestPipelineMiddleware.js